import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { SearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_staff/attendances/_layout/operation-activity/')({
  validateSearch: zodValidator(SearchSchema)
});